<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter22">
<h1><a id="page_40"></a><a href="#/003toc#ch22">Vegetarian Confetti Split Pea Soup</a></h1>
<p class="noindent">Split pea soup is a favorite at my house, but it usually has a base of smoked sausage or a ham bone to give it flavor and punch. When I decided to try a vegetarian version, I added yellow split peas and red lentils to give the soup beautiful color and flavor.</p>
<p class="noindent">2 tablespoons olive oil</p>
<p class="noindent">1 large onion, chopped</p>
<p class="noindent">4 medium carrots, diced</p>
<p class="noindent">4 stalks celery, diced</p>
<p class="noindent">2 teaspoons dried thyme</p>
<p class="noindent">1 bay leaf</p>
<p class="noindent">2 cups dried green split peas</p>
<p class="noindent">1 cup dried yellow split peas</p>
<p class="noindent">½ cup dried red lentils</p>
<p class="noindent">8 cups vegetable broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">heat the oil in a skillet over medium-high heat. Add the onion, carrots, celery, thyme, and bay leaf and sauté until the vegetables begin to soften, 4 to 5 minutes.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker and add the split peas, lentils, and broth, and stir to combine.</p>
<p class="noindent">cover the slow cooker and cook on high for 4 hours or on low for 8 hours; check the soup at 3 or 7 hours to make sure that it isn’t sticking to the pot. If it appears too thick, add more broth.</p>
<p class="noindent">season with salt and pepper before serving.</p>
<p class="noindent">serves 8</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 028-chapter22.vue?1e4ab340